import { render, staticRenderFns } from "./SidenavCollapseIcon.vue?vue&type=template&id=b7fd2f22&"
import script from "./SidenavCollapseIcon.vue?vue&type=script&lang=js&"
export * from "./SidenavCollapseIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports